import { LogOut, FileText, Images, LayoutGrid, Building2, ShoppingBag, Wrench, Store, Package, Tag } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { QuotesTab } from "@/components/admin/QuotesTab";
import { GalleryManager } from "@/components/admin/GalleryManager";
import { BusinessInfoTab } from "@/components/admin/BusinessInfoTab";
import { ShopTab } from "@/components/admin/ShopTab";
import { ServicesManager } from "@/components/admin/ServicesManager";
import { StoreTab } from "@/components/admin/StoreTab";
import { OrdersTab } from "@/components/admin/OrdersTab";
import { DiscountsTab } from "@/components/admin/DiscountsTab";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

export default function AdminDashboard() {
  const { user, logout } = useAuth();

  return (
    <div data-testid="admin-dashboard-page" className="bg-paper min-h-screen">
      {/* Dashboard header */}
      <div className="bg-ink text-[#f2f0ea] pt-[128px] pb-10">
        <div className="max-w-[1200px] mx-auto px-5 lg:px-8 flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs tracking-[0.3em] text-gold font-semibold mb-2">SHOP DASHBOARD</p>
            <h1 className="font-display text-4xl sm:text-5xl tracking-[0.02em]">WELCOME BACK</h1>
            <p className="text-white/55 text-sm mt-2">{user?.email}</p>
          </div>
          <button onClick={logout} data-testid="logout-button"
            className="flex items-center gap-2 border border-white/25 px-5 py-2.5 text-xs font-bold tracking-[0.14em] hover:bg-white/10 transition-colors">
            <LogOut size={15} /> SIGN OUT
          </button>
        </div>
      </div>

      <section className="py-12">
        <div className="max-w-[1200px] mx-auto px-5 lg:px-8">
          <Tabs defaultValue="quotes" className="w-full">
            <TabsList className="bg-transparent p-0 h-auto gap-2 mb-10 flex-wrap justify-start border-b border-line w-full rounded-none">
              <TabsTrigger value="quotes" data-testid="tab-quotes"
                className="data-[state=active]:bg-ink data-[state=active]:text-[#f2f0ea] data-[state=active]:shadow-none rounded-none px-5 py-3 text-xs font-bold tracking-[0.12em] text-navy/60">
                <FileText size={15} className="mr-2" /> QUOTE REQUESTS
              </TabsTrigger>
              <TabsTrigger value="orders" data-testid="tab-orders"
                className="data-[state=active]:bg-ink data-[state=active]:text-[#f2f0ea] data-[state=active]:shadow-none rounded-none px-5 py-3 text-xs font-bold tracking-[0.12em] text-navy/60">
                <Package size={15} className="mr-2" /> ORDERS
              </TabsTrigger>
              <TabsTrigger value="store" data-testid="tab-store"
                className="data-[state=active]:bg-ink data-[state=active]:text-[#f2f0ea] data-[state=active]:shadow-none rounded-none px-5 py-3 text-xs font-bold tracking-[0.12em] text-navy/60">
                <Store size={15} className="mr-2" /> SPIRIT STORE
              </TabsTrigger>
              <TabsTrigger value="discounts" data-testid="tab-discounts"
                className="data-[state=active]:bg-ink data-[state=active]:text-[#f2f0ea] data-[state=active]:shadow-none rounded-none px-5 py-3 text-xs font-bold tracking-[0.12em] text-navy/60">
                <Tag size={15} className="mr-2" /> DISCOUNTS
              </TabsTrigger>
              <TabsTrigger value="gallery" data-testid="tab-gallery"
                className="data-[state=active]:bg-ink data-[state=active]:text-[#f2f0ea] data-[state=active]:shadow-none rounded-none px-5 py-3 text-xs font-bold tracking-[0.12em] text-navy/60">
                <Images size={15} className="mr-2" /> GALLERY
              </TabsTrigger>
              <TabsTrigger value="categories" data-testid="tab-categories"
                className="data-[state=active]:bg-ink data-[state=active]:text-[#f2f0ea] data-[state=active]:shadow-none rounded-none px-5 py-3 text-xs font-bold tracking-[0.12em] text-navy/60">
                <LayoutGrid size={15} className="mr-2" /> CATEGORY CARDS
              </TabsTrigger>
              <TabsTrigger value="shop" data-testid="tab-shop"
                className="data-[state=active]:bg-ink data-[state=active]:text-[#f2f0ea] data-[state=active]:shadow-none rounded-none px-5 py-3 text-xs font-bold tracking-[0.12em] text-navy/60">
                <ShoppingBag size={15} className="mr-2" /> SHOP ITEMS
              </TabsTrigger>
              <TabsTrigger value="services" data-testid="tab-services"
                className="data-[state=active]:bg-ink data-[state=active]:text-[#f2f0ea] data-[state=active]:shadow-none rounded-none px-5 py-3 text-xs font-bold tracking-[0.12em] text-navy/60">
                <Wrench size={15} className="mr-2" /> SERVICES
              </TabsTrigger>
              <TabsTrigger value="business" data-testid="tab-business"
                className="data-[state=active]:bg-ink data-[state=active]:text-[#f2f0ea] data-[state=active]:shadow-none rounded-none px-5 py-3 text-xs font-bold tracking-[0.12em] text-navy/60">
                <Building2 size={15} className="mr-2" /> BUSINESS INFO
              </TabsTrigger>
            </TabsList>

            <TabsContent value="quotes"><QuotesTab /></TabsContent>
            <TabsContent value="orders"><OrdersTab /></TabsContent>
            <TabsContent value="store"><StoreTab /></TabsContent>
            <TabsContent value="discounts"><DiscountsTab /></TabsContent>
            <TabsContent value="gallery"><GalleryManager type="gallery" /></TabsContent>
            <TabsContent value="categories"><GalleryManager type="category" /></TabsContent>
            <TabsContent value="shop"><ShopTab /></TabsContent>
            <TabsContent value="services"><ServicesManager /></TabsContent>
            <TabsContent value="business"><BusinessInfoTab /></TabsContent>
          </Tabs>
        </div>
      </section>
    </div>
  );
}
